module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon16.png?37e87524";